import dynamic from 'next/dynamic';
import { GuestRoomsProps } from './GuestRooms.types';

export const GuestRooms = dynamic<{ model: GuestRoomsProps }>(() => import('./GuestRooms').then(mod => mod.GuestRooms));
